import './Loader.css';

export default function Loader() {
  return (
    <div className="overlay">
      <span className="spinner" />
    </div>
  );
}
